
  import React from "react"
  import Component from "/Users/colemerrick/passion/project_surf_helmet/src/layouts/index.js"
  import data from "/Users/colemerrick/passion/project_surf_helmet/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js